module.exports = __webpack_public_path__ + "img/slim.17a0d62c.png";